module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/205/assets/images/7c39a9c1f746b3ce5b2f4f31bdec3ca2.svg";


//////////////////
// WEBPACK FOOTER
// ./components/toast/assets/warning-icon.svg
// module id = Oi3E
// module chunks = 1